export const locale = {
    lang: 'en',
    data: {
        'NAV': {

            'DASHBOARDS': 'Dashboards',
            'UserRole': 'UserRole',
            // AutoTransfer
            'CompanyBases': 'CompanyBases',
            'Individualbase': 'Individualbase',
            'Transferdetails': 'Transferdetails',
            'blocktransfer': 'Block Transfer',
            'report' :' Reports',
            // Auto Repayment
            'autopaycompanybase': 'Auto Pay Company Base',
            'autopayindividualbase': 'Auto Pay Individual Base',
            'autopaytransferdetails': 'Auto Pay Transfer Detail',
            'autoblocktransfer': 'Block Transfers',
            'autopayreport': 'Auto Pay Report',
            // 'login':'login',
             'changepassword':'Change Password',
              'Logout':'logout'

        }
    }
};
